<template>
    <svg height="40" class="case_type" :class="caseType == 'Чиновники' ? 'clerk' : 'business'">
        <text x="0" y="39">{{ caseType }}</text>
    </svg>
</template>

<script>
export default {
    name: 'CaseType',
    props: { caseType:{ default:'' } },
    methods: {}
}
</script>

<style lang="scss">
</style>